/** Why an attach request failed, for the host app to word its message. */
var RulebookAttachFailure;
(function (RulebookAttachFailure) {
    RulebookAttachFailure["NotPublicForPublicCharacter"] = "notPublicForPublicCharacter";
    RulebookAttachFailure["Unavailable"] = "unavailable";
    RulebookAttachFailure["Failed"] = "failed";
})(RulebookAttachFailure || (RulebookAttachFailure = {}));
export default RulebookAttachFailure;
